// Hook listy pozycji kalkulacji oferty –
// GET /sales-crm/clients/:cid/offers/:oid/calculations/:calcId/positions

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export type CalculationPositionPriceType = 'UNIT' | 'TOTAL';

export interface ISalesCrmOfferCalculationPosition {
  id: number;
  name: string;
  productId: number | null;
  serviceId: number | null;
  priceType: CalculationPositionPriceType;
  priceNet: number;
  priceGross: number | null;
  taxPercent: number;
  /** Wartość netto pozycji wyliczona po stronie backendu = priceNet (ilość pochodzi z pozycji oferty). */
  valueNet?: number | null;
  /** Wartość brutto pozycji wyliczona po stronie backendu. */
  valueGross?: number | null;
  /** Koszt własny netto — ile placimy dostawcy/wykonawcy (do realnej marzy). null = nie podano. */
  costNet?: number | null;
}

export interface ISalesCrmOfferCalculationPositionsResponse {
  page: number;
  total_count: number;
  total_pages: number;
  items: ISalesCrmOfferCalculationPosition[];
  /** Sumy całej kalkulacji + waluta — wyliczane przez RecalculateOfferVersionCalculationTotalsService. */
  totals?: {
    valueNet: number;
    valueGross: number;
    currency: string | null;
  };
}

export const getSalesCrmOfferCalculationPositionsQueryKey = (calculationId: number) =>
  ['salesCrm', 'offerCalculation', calculationId, 'positions'] as const;

const getSalesCrmOfferCalculationPositions = (
  clientId: number,
  offerId: string,
  calculationId: number
): Promise<ISalesCrmOfferCalculationPositionsResponse> =>
  axios.get(
    `/sales-crm/clients/${clientId}/offers/${offerId}/calculations/${calculationId}/positions`
  );

export const useGetSalesCrmOfferCalculationPositions = (
  clientId: number,
  offerId: string,
  calculationId: number,
  options?: UseQueryOptions<ISalesCrmOfferCalculationPositionsResponse, IError>
) =>
  useQuery<ISalesCrmOfferCalculationPositionsResponse, IError>(
    getSalesCrmOfferCalculationPositionsQueryKey(calculationId),
    () => getSalesCrmOfferCalculationPositions(clientId, offerId, calculationId),
    {
      ...options,
      enabled:
        options?.enabled !== false &&
        clientId > 0 &&
        String(offerId).trim().length > 0 &&
        calculationId > 0
    }
  );
